import React, { useState } from 'react';
import { TableCell } from '@material-ui/core';
import ListView from 'components/Crud/views/List';
import { skillDomain, engineerDomain } from 'models';
import { useSkillsData } from 'store/selectors';
import {
  ListTable,
  TableActions,
  useTableRowActionsState,
  useTableStyles
} from 'components/Crud/ListTable/ListTable';
import ListTableRow from 'components/Crud/ListTable/ListTableRow';
import Skill from 'models/Skills';
import SkillModal from './SkillModal';

const SkillsView = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentSkill, setCurrentSkill] = useState<Skill>();
  const skillsData = useSkillsData();
  const classes = useTableStyles({ containerSize: 'medium' });
  const { rowHovered, setRowHovered } = useTableRowActionsState();
  const columnsWidth = [480, 360];
  const openModal = () => setIsModalOpen(true);

  const openEditModal = (skill: Skill) => {
    openModal();
    setCurrentSkill(skill);
  };

  const cancelModal = () => {
    setIsModalOpen(false);
    setCurrentSkill(undefined);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentSkill(undefined);
  };

  return (
    <>
      <ListView disableErrorDisplay domain={skillDomain}>
        {({ onDelete }) => (
          <section className={classes.tableContainer}>
            <ListTable
              domain={skillDomain}
              domainItems={skillsData}
              columnsWidth={columnsWidth}
              setRowHovered={(row: number | boolean) => setRowHovered(row)}
              rowHovered={rowHovered}
              title={skillDomain.label}
              label={`A table of ${engineerDomain.label} ${skillDomain.plural}`}
              headerButtons={[
                {
                  label: 'New Skill',
                  openModal
                }
              ]}
            >
              {skillsData.map((skill, index) => (
                <ListTableRow
                  key={skill.id}
                  data-testid={`tableRow-${skill.id}`}
                >
                  <TableCell className={classes.tableCell}>
                    {skill.name}
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    {skill.category.name}
                  </TableCell>
                  {rowHovered !== index ? (
                    <TableCell className={classes.tableCell}>&nbsp;</TableCell>
                  ) : (
                    <TableActions
                      onEdit={() => () => openEditModal(skill)}
                      onDelete={onDelete}
                      domain={skillDomain}
                      domainItem={skill}
                    />
                  )}
                </ListTableRow>
              ))}
            </ListTable>
          </section>
        )}
      </ListView>
      <SkillModal
        open={isModalOpen}
        closeModal={closeModal}
        currentSkill={currentSkill}
        cancel={cancelModal}
      />
    </>
  );
};

export default SkillsView;
